import React from "react";

const AssessementCard = ({ title, description, iconImg }) => {
  return (
    <div
      className="p-4 flex-grow-1"
      style={{
        backgroundColor: "#FFFFFF",
        minWidth: "0", // Prevent overflow issues
        flexBasis: "0", // Ensures equal distribution
      }}
    >
      <div className="text-center">
        <img
          src={iconImg}
          alt=""
          style={{
            minWidth: "50%",
          }}
        />
      </div>
      <h3 className="text-center mt-4">{title}</h3>
      <p className="text-center mt-3 fs-5">{description}</p>
    </div>
  );
};

export default AssessementCard;
